__turbopack_context__.v({
  "iconElectricity": "-QFrFW_iconElectricity",
  "iconGas": "-QFrFW_iconGas",
});
